import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from './business-component/chart'
import { BcacIconModule } from './base-component/currency/bcac-icon';
import { BcacTableModule } from './business-component/bcac-table';
import { BcacModalModule } from './base-component/currency/bcac-modal';
import { BcacFormModule } from 'bcac-lib/base-component/currency/bcac-form';
import { BcacMultipleSelectModule } from 'bcac-lib/base-component/currency/bcac-multiple-select';



@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    ChartModule,
    BcacIconModule,
    BcacTableModule,
    BcacModalModule,
    BcacFormModule,
    BcacMultipleSelectModule
  ],
  declarations: []
})
export class BcacLibModule { }
